const addVatToPrice = (node) => {
  const textArray = node.innerText.split(' ');
  let price = textArray.shift();
  price = price.replace('.', '').replace(',', '');
  price = parseFloat(price);
  price = Shopify.formatMoney(price * theme.vat);

  node.innerText = price;
  node.classList.add('price-updated');
};

const addVatToPriceToFomo = (node) => {
  const textWithoutComma = node.innerText.replace(',', '.')
  const textArray = textWithoutComma.split(' ');

  let price;

  const numberArray = [];
  textArray.forEach((text) => {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(text)) {
      numberArray.push(parseFloat(text).toFixed(2));
    }
  });

  if (numberArray.length > 0) {
    price = numberArray[numberArray.length - 1];
  } else {
    return;
  }

  const oldPriceString = parseFloat(price).toFixed(2).replace('.', ',');
  const newPriceString = parseFloat(price * theme.vat).toFixed(2).toString().replace('.', ',');

  node.innerText = node.innerText.replace(oldPriceString, newPriceString);
};

// Select the element to observe
const cartForm = document.querySelector('.js-cart-form');

if (cartForm) {
  // Create an observer instance with a callback function
  const cartObserver = new MutationObserver(((mutations) => {
    // Loop through the mutations list
    // eslint-disable-next-line no-restricted-syntax
    for (const mutation of mutations) {
      // Check if the mutation is a child list mutation
      if (mutation.type === 'childList') {
        // Do something when a child node is added or removed

        if (mutation.target.getAttribute('data-hulkapps-ci-price') !== null || mutation.target.getAttribute('data-hulkapps-line-price') !== null) {
          mutation.addedNodes.forEach((node) => {
            if (node.classList.contains('price-updated')) return;
            if (node.classList.contains('original_price') || node.classList.contains('discounted_price')) {
              addVatToPrice(node);
            }
          });
        } else if (mutation.target.getAttribute('data-hulkapps-cart-total-price') !== null) {
        // if (mutation.target.getAttribute('data-price-update-ignore') !== null) return;

          const parent = mutation.target.parentElement;
          const { children } = parent;
          if (!children.length > 0) return;
          const childArray = Array.from(parent.children);

          childArray.forEach((node) => {
            if (node.classList.contains('price-updated')) return;
            if (node.classList.contains('original_price')
                            || node.classList.contains('discounted_price')
                            || node.classList.contains('hulkapps-cart-original-total')
                            || node.classList.contains('hulkapps-cart-total')) {
              addVatToPrice(node);
            }
          });
        } else if (mutation.target.classList.contains('hulkapps-reminder')) {
          const { children } = mutation.target;
          if (!children.length > 0) return;
          const childArray = Array.from(children);
          childArray.forEach((node) => {
            if (node.classList.contains('hulkapps-reminder-msg')) {
              addVatToPriceToFomo(node);
            }
          });
        }
      }
    }
  }));

  // Specify what kinds of mutations to observe
  const config = { childList: true, subtree: true };

  // Start observing the target element
  cartObserver.observe(cartForm, config);
}
